(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const buttonOriginals = new WeakMap();
  const explicitlySelectedProducts = new Set();
  const dockHysteresis = 6;
  let row = null;
  let anchor = null;
  let naturalHeight = 0;
  let fixedHeight = 0;
  let frame = 0;
  let mutationFrame = 0;

  function getMainPicker() {
    return document.querySelector(
      'variant-picker[context="main_product"][data-requires-explicit-color-selection]'
    );
  }

  function getPurchaseButton() {
    return document.querySelector('.product-purchase-row buy-buttons button[type="submit"], .product-purchase-row buy-buttons button[data-ctd-original-type="submit"]');
  }

  function hasExplicitColorSelection(picker) {
    return picker?.dataset.explicitColorSelected === 'true'
      || explicitlySelectedProducts.has(picker?.getAttribute('handle'));
  }

  function setSelectionRequired(required) {
    const picker = getMainPicker();
    const button = getPurchaseButton();

    if (!picker || !button) return;

    const isCurrentlyRequired = button.classList.contains('ctd-color-selection-required');
    if (isCurrentlyRequired === required) return;

    if (!buttonOriginals.has(button)) {
      buttonOriginals.set(button, {
        html: button.innerHTML,
        type: button.getAttribute('type') || 'submit'
      });
    }

    const original = buttonOriginals.get(button);
    button.classList.toggle('ctd-color-selection-required', required);
    button.setAttribute('aria-disabled', required ? 'true' : 'false');

    if (required) {
      button.dataset.ctdOriginalType = original.type;
      button.type = 'button';
      const selectionLabel = document.createElement('span');
      selectionLabel.className = 'ctd-color-selection-required__label';
      selectionLabel.textContent = picker.dataset.colorSelectLabel || 'Kleur selecteren';
      button.replaceChildren(selectionLabel);
    } else {
      button.type = original.type;
      button.removeAttribute('data-ctd-original-type');
      button.innerHTML = original.html;
    }
  }

  function clearPreselectedColor(picker) {
    if (picker.dataset.ctdColorInitialized === 'true') return;

    if (!hasExplicitColorSelection(picker)) {
      picker.querySelectorAll('[data-color-option]').forEach((colorOption) => {
        colorOption.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
          input.checked = false;
        });

        colorOption.querySelectorAll('.color-swatch.is-selected').forEach((swatch) => {
          swatch.classList.remove('is-selected');
        });

        const selectedValue = colorOption.querySelector(
          '.variant-picker__option-info .h-stack > span'
        );

        if (selectedValue) selectedValue.textContent = picker.dataset.colorPlaceholderLabel || 'Kies een kleur';
      });
    }

    picker.dataset.ctdColorInitialized = 'true';
    picker.dataset.explicitColorSelected = hasExplicitColorSelection(picker) ? 'true' : 'false';
  }

  function focusColorPicker() {
    const picker = getMainPicker();
    const colorOption = picker?.querySelector('[data-color-option]');

    if (!colorOption) return;

    colorOption.scrollIntoView({ behavior: 'smooth', block: 'center' });
    colorOption.classList.remove('ctd-color-option--attention');
    window.requestAnimationFrame(() => colorOption.classList.add('ctd-color-option--attention'));
  }

  function initializeColorSelection() {
    const picker = getMainPicker();
    if (!picker) return;

    clearPreselectedColor(picker);

    const button = getPurchaseButton();
    const canSelectVariant = Boolean(button && !button.disabled);
    setSelectionRequired(canSelectVariant && !hasExplicitColorSelection(picker));
  }

  document.addEventListener('change', (event) => {
    const colorInput = event.target.closest(
      'variant-picker[context="main_product"] [data-color-option] input'
    );

    if (!colorInput) return;

    const picker = colorInput.closest('variant-picker');
    const colorOption = colorInput.closest('[data-color-option]');
    const selectedSwatch = colorInput.nextElementSibling;

    explicitlySelectedProducts.add(picker.getAttribute('handle'));
    picker.dataset.explicitColorSelected = 'true';

    colorOption?.querySelectorAll('.color-swatch.is-selected').forEach((swatch) => {
      swatch.classList.remove('is-selected');
    });

    selectedSwatch?.classList.add('is-selected');

    const selectedValue = colorOption?.querySelector(
      '.variant-picker__option-info .h-stack > span'
    );
    const selectedLabel = selectedSwatch?.querySelector('.color-swatch__tooltip, .sr-only');

    if (selectedValue && selectedLabel) {
      selectedValue.textContent = selectedLabel.textContent.trim();
    }

    setSelectionRequired(false);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.ctd-color-selection-required');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    focusColorPicker();
  }, true);

  function setFixed(shouldFix) {
    if (!row || !anchor) return;

    const isFixed = row.classList.contains('is-mobile-pre-docked');
    if (isFixed === shouldFix) return;

    row.classList.toggle('is-mobile-pre-docked', shouldFix);
    anchor.hidden = !shouldFix;
    anchor.style.height = shouldFix ? `${naturalHeight}px` : '0px';
    document.body.classList.toggle('has-mobile-purchase-dock', shouldFix);
    if (shouldFix) fixedHeight = row.getBoundingClientRect().height;
  }

  function update() {
    frame = 0;
    if (!mobileQuery.matches || !row || !row.isConnected || !anchor || !anchor.isConnected) {
      if (!mobileQuery.matches) setFixed(false);
      return;
    }
    const reference = row.classList.contains('is-mobile-pre-docked') ? anchor : row;
    const referenceTop = reference.getBoundingClientRect().top;
    const dockLine = window.innerHeight - (fixedHeight || naturalHeight);
    const isFixed = row.classList.contains('is-mobile-pre-docked');
    const shouldFix = isFixed
      ? referenceTop > dockLine - dockHysteresis
      : referenceTop > dockLine + dockHysteresis;

    setFixed(shouldFix);
  }

  function scheduleUpdate() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  function cleanupDock() {
    if (row) row.classList.remove('is-mobile-pre-docked');
    if (anchor) anchor.remove();
    document.body.classList.remove('has-mobile-purchase-dock');
    row = null;
    anchor = null;
    naturalHeight = 0;
    fixedHeight = 0;
  }

  function setup() {
    initializeColorSelection();

    const nextRow = document.querySelector('.product-purchase-row');
    if (!mobileQuery.matches || !nextRow) {
      cleanupDock();
      return;
    }
    if (row === nextRow && anchor && anchor.isConnected) {
      if (!row.classList.contains('is-mobile-pre-docked')) {
        naturalHeight = Math.ceil(row.getBoundingClientRect().height);
      }

      scheduleUpdate();
      return;
    }
    cleanupDock();
    row = nextRow;
    naturalHeight = Math.ceil(row.getBoundingClientRect().height);
    anchor = document.createElement('div');
    anchor.className = 'mobile-purchase-anchor';
    anchor.hidden = true;
    anchor.setAttribute('aria-hidden', 'true');
    row.before(anchor);
    fixedHeight = naturalHeight;
    scheduleUpdate();
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', setup);
  window.addEventListener('pageshow', setup);
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:select', setup);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleUpdate);
    window.visualViewport.addEventListener('scroll', scheduleUpdate);
  }

  new MutationObserver(() => {
    if (mutationFrame) return;

    mutationFrame = window.requestAnimationFrame(() => {
      mutationFrame = 0;
      setup();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
